import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@coolblue-development/freddy';
import { CategoryNavigationGroup } from './CategoryNavigationBar.styled.js';
export default function CategoryNavigationBarGroup({ onMouseOver, isActive, group, }) {
    return (_jsx(CategoryNavigationGroup, { tabIndex: 0, onMouseOver: onMouseOver, isActive: isActive, children: _jsx(Typography, { color: "interactiveBase", fontWeight: 600, textAlign: "center", children: group.title }) }));
}
//# sourceMappingURL=CategoryNavigationBarGroup.js.map